export const getToggleableStyles = palette => ({
  toggleable: {
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'none',
      border: 'none !important',
      backgroundColor: `${palette.themeDarkAlt} !important`,
    },
    '&:active, &:focus': {
      textDecoration: 'none',
      border: 'none !important',
      outline: 'none !important',
      backgroundColor: `${palette.neutralLighterAlt} !important`,
      color: `${palette.neutralPrimary} !important`,
      '&:after': {
        border: 'none !important',
      },
    },
  },
});
